import md5 from 'md5';

const defaultAvatar =
  'https%3A%2F%2Fmy.appcues.com%2Fimages%2Favatar.png&s=256';

export const getGravatarUrlFromEmail = email =>
  `https://www.gravatar.com/avatar/${md5(
    (email || '').trim().toLowerCase()
  )}?d=${defaultAvatar}`;
